var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 65,
    viewBox: "0 0 67 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.5V58.5H60.5V19.5H15ZM15 13H60.5V6.5H15V13ZM63.75 65H11.75C10.888 65 10.0614 64.6576 9.4519 64.0481C8.84241 63.4386 8.5 62.612 8.5 61.75V3.25C8.5 2.38805 8.84241 1.5614 9.4519 0.951903C10.0614 0.34241 10.888 0 11.75 0H63.75C64.612 0 65.4386 0.34241 66.0481 0.951903C66.6576 1.5614 67 2.38805 67 3.25V61.75C67 62.612 66.6576 63.4386 66.0481 64.0481C65.4386 64.6576 64.612 65 63.75 65ZM21.5 26H34.5V39H21.5V26ZM21.5 45.5H54V52H21.5V45.5ZM41 29.25H54V35.75H41V29.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19H6.5V19.5V58.5V59H7H52.5H53V58.5V19.5V19H52.5H7ZM6.5 13V13.5H7H52.5H53V13V6.5V6H52.5H7H6.5V6.5V13ZM55.75 64.5H3.75C3.02065 64.5 2.32118 64.2103 1.80546 63.6945C1.28973 63.1788 1 62.4793 1 61.75V3.25C1 2.52065 1.28973 1.82118 1.80546 1.30546C2.32118 0.789731 3.02065 0.5 3.75 0.5H55.75C56.4793 0.5 57.1788 0.789732 57.6945 1.30546C58.2103 1.82118 58.5 2.52065 58.5 3.25V61.75C58.5 62.4793 58.2103 63.1788 57.6945 63.6945C57.1788 64.2103 56.4793 64.5 55.75 64.5ZM14 26.5H26V38.5H14V26.5ZM14 46H45.5V51.5H14V46ZM33.5 29.75H45.5V35.25H33.5V29.75Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService2);
export default __webpack_public_path__ + "static/media/Service2.e567f614a6677302211c016d887cb24e.svg";
export { ForwardRef as ReactComponent };